import Mark from 'mark.js'

export default {
  data() {
    return {
      clearHightlight: null
    }
  },
  methods: {
    highlight() {
      const ob = new Mark(document.querySelectorAll('.content-area__content'))
      ob.unmark()
      ob.mark(document.getElementById('search').value,
        { className: 'highlight' }
      )
    },
    handleShowHightlightInPageMixin(highlight) {
      const element = document.getElementById(highlight)
      //this.handleHideHightLightInPage(highlight, arrayHighlightId)
      element.style.scrollMarginTop = '10px'
      //element.style.border = '3px solid #FFD43A'
      element.scrollIntoView()
      window.scrollBy(0, -250)
    
    },
    handleHideHightLightInPage(highlight, arrayHighlightId) {
      const idHightlighted = arrayHighlightId
      const idHightlightedOnClick = idHightlighted.filter(ele => ele !== highlight)
      idHightlightedOnClick.forEach((ele) => {
        const element = document.getElementById(ele)
        if(element) {
          element.style.border = 'none'
        }
      })
      clearTimeout(this.clearHightlight)
      const element = document.getElementById(highlight)
      this.clearHightlight = setTimeout(() => {
        if(element) {
          element.style.border = 'none'
        }
      }, 10000)
    }
  }
}
